import { ActivationPackagePhotoCategory, AllDocumentTypes, RequirementFlagSettingsType, ProgramType } from 'types';

import FormSection from '../Forms/FormSection';
import { PhotosList } from '../MilestonePackagePartials/Documents/PhotosList';

type SiteImprovementProps = {
  showCheckboxes: boolean;
  checkboxCategories: AllDocumentTypes[];
  programType: ProgramType;
  isPackageEditable?: boolean;
};

export const SiteImprovement = ({
  showCheckboxes,
  checkboxCategories,
  programType,
  isPackageEditable = true,
}: SiteImprovementProps) => {
  return (
    <FormSection
      title="Site Improvement"
      description="if applicable, photos of the site improvements made such as tree removal or main panel upgrade."
    >
      <PhotosList
        title="Site Improvement Photos"
        category={ActivationPackagePhotoCategory.siteImprovements}
        baseCategory="Activation Photo Documentation"
        flagType={RequirementFlagSettingsType.siteImprovement}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        programType={programType}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
